/**
 * Модуль slides_white: табы + карусель (tiny-slider).
 */
import 'tiny-slider/dist/tiny-slider.css';
import { tns } from 'tiny-slider/src/tiny-slider';

export function initSlidesWhite() {
    const carousel = document.querySelector('[data-slides-white]');
    if (!carousel) {
        return;
    }

    const root = carousel.closest('.slides_white') || document;
    const tabs = Array.from(root.querySelectorAll('.slides_white__tab'));
    const track = carousel.querySelector('.slides_white__track');
    const slides = track ? Array.from(track.querySelectorAll('.slides_white__slide')) : [];
    if (!tabs.length || !track || !slides.length || carousel.dataset.slidesWhiteReady === '1') {
        return;
    }
    carousel.dataset.slidesWhiteReady = '1';

    // Индекс активного слайда — до сброса классов (иначе findIndex даст -1)
    const markedIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    const startIndex = markedIndex >= 0 ? markedIndex : 0;

    slides.forEach((slide, index) => {
        slide.setAttribute('data-slide-index', String(index));
        // Активный не трогаем до init — иначе сработает transition «появления» и мигнёт layout
        if (index !== startIndex) {
            slide.classList.remove('is-active', 'is-near');
        }
    });

    // Без transition на время сборки tiny-slider (иначе scale/opacity анимируются в тот же кадр, что и CLS)
    carousel.classList.add('slides_white__carousel--booting');

    const state = {
        slider: null,
        currentIndex: startIndex,
    };

    function normalizeIndex(index) {
        const total = slides.length;
        if (!total) {
            return 0;
        }
        return ((index % total) + total) % total;
    }

    function updateTabs(index) {
        tabs.forEach((tab, i) => {
            const active = i === index;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
    }

    const tabsScroller = root.querySelector('.slides_white__tabs');

    // На узком экране активный таб по возможности по центру полосы (края — насколько позволяет скролл)
    function scrollTabIntoView(tab) {
        if (!tab || !tabsScroller) {
            return;
        }

        const scrollerRect = tabsScroller.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const delta = (tabRect.left + tabRect.width / 2) - (scrollerRect.left + scrollerRect.width / 2);
        const maxScroll = tabsScroller.scrollWidth - tabsScroller.clientWidth;
        const nextScroll = Math.max(0, Math.min(maxScroll, tabsScroller.scrollLeft + delta));

        if (Math.abs(nextScroll - tabsScroller.scrollLeft) < 1) {
            return;
        }

        tabsScroller.scrollTo({ left: nextScroll, behavior: 'smooth' });
    }

    function updateSlides(index) {
        const allSlides = Array.from(carousel.querySelectorAll('.slides_white__slide'));
        const prevIndex = normalizeIndex(index - 1);
        const nextIndex = normalizeIndex(index + 1);

        allSlides.forEach((slide) => {
            const slideIndex = Number(slide.getAttribute('data-slide-index'));
            const active = slideIndex === index;
            const near = slideIndex === prevIndex || slideIndex === nextIndex;
            slide.classList.toggle('is-active', active);
            slide.classList.toggle('is-near', near);
        });
    }

    function getCurrentSlideIndex(info) {
        if (!info || typeof info.index !== 'number') {
            return state.currentIndex;
        }
        return normalizeIndex(info.index - info.cloneCount);
    }

    function setActive(index) {
        state.currentIndex = normalizeIndex(index);
        updateTabs(state.currentIndex);
        updateSlides(state.currentIndex);
    }

    state.slider = tns({
        container: track,
        items: 1,
        center: true,
        gutter: 16,
        edgePadding: 40,
        loop: true,
        startIndex: startIndex,
        controls: false,
        nav: false,
        autoplay: false,
        mouseDrag: true,
        swipeAngle: 15,
        speed: 350,
        preventScrollOnTouch: 'force',
        responsive: {
            0: {
                edgePadding: 12,
            },
            768: {
                edgePadding: 24,
            },
            1200: {
                edgePadding: 40,
            },
        },
    });

    tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
            if (!state.slider) {
                return;
            }
            const targetIndex = Number(tab.getAttribute('data-slide')) || 0;
            state.slider.goTo(targetIndex);
        });
    });

    slides.forEach((slide, index) => {
        slide.addEventListener('click', () => {
            if (!state.slider) {
                return;
            }
            state.slider.goTo(index);
        });
    });

    state.slider.events.on('indexChanged', (event) => {
        setActive(getCurrentSlideIndex(event));
        scrollTabIntoView(tabs[state.currentIndex]);
    });

    state.slider.events.on('transitionEnd', () => {
        const info = state.slider ? state.slider.getInfo() : null;
        setActive(getCurrentSlideIndex(info));
    });

    setActive(startIndex);

    // Включаем transition после двух кадров — когда layout после tns уже стабилен
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            carousel.classList.remove('slides_white__carousel--booting');
        });
    });
}
